import store from '@/store'

export default {
  handle(topic) {
    console.log('notification received......', topic)
    const project = store.state.project?.project
    if (project.name) store.dispatch('notification/fetchNotifications', { projectUid: project.uuid })
  },
}
